import { types as mediaTypes } from "../../../MediaLibrary/Media";

export const SUPPORTED_MEDIA_TYPES = [
  mediaTypes.IMAGE,
  mediaTypes.VIDEO,
  mediaTypes.AUDIO,
  mediaTypes.PHRASE,
];
